import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import userSaga from './userSaga';
import adminSaga from './adminSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    userSaga(),
    adminSaga(),
  ]);
}